// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"ho","contentFrame":"hp","buttonGroup":"hq","button":"hr","header":"hs","text":"ht","contentImage":"hu"};